import React from 'react'
import { IWithSize } from '../../../containers/BookingCalendar/Calendar/Calendar'
import HeaderInside from './HeaderInside'
import HeaderWrapper from './HeaderWrapper'

const Header = ({
  children,
  isSidebarOpen,
  size = 1,
}: IHeaderProps & IWithSize) => (
  <HeaderWrapper size={size} isSidebarOpen={isSidebarOpen}>
    <HeaderInside
      size={size}
      full={true}
      justifyStart={true}
      alignCenter={true}
    >
      {React.Children.map(children, element => element)}
    </HeaderInside>
  </HeaderWrapper>
)

export default Header

export interface IHeaderProps {
  children: React.ReactNode
  isSidebarOpen: boolean
}
